import React, { useState } from 'react'
import { Card, Button, Input } from 'components/ui'
import { Alert } from 'components/ui'
import { App } from 'realm-web'
import './ParentRef.css'
function ParentRef({ setParentRefSubmitted }) {
    const onCloseClick = () => {
        console.log('Alert closed!')
    }
    // const app = new App({ id: 'data-wallet-psyew' })
    const app = new App({ id: process.env.REACT_APP_APP_ID })

    const [parentRef, setParentRef] = useState('')
  const [parentUserId, setParentUserId] = useState('')
    const [parentReferalWarning, setParentReferalWarning] = useState(false)
    const [warningType, setWarningType] = useState('')
    const [parentRefWarningMessage, setParentRefWarningMessage] = useState('')

    async function addPap() {
        try {
          
            await app.currentUser.functions.fn_pap_add_parentRef_to_users(
                parentRef
            )
            return true
        } catch (err) {
            console.log('err', err)
            return false
        }
    }
    async function checkParentRefValidation() {
        let apiObj = {
            refid: parentRef,
        }
        const res = await app.currentUser.functions.fn_find_pap_by_refid(apiObj)

        // if (res.status !== 200) {
        //     setParentReferalWarning(true)
        //     setParentRefWarningMessage('Parent ref is not valid.')
        //     setWarningType('danger')
        //     return false
        // } else {
        //     return true
        // }
        if (res.status !== 200) {
            setParentReferalWarning(true)
            setParentRefWarningMessage('Parent ref is not valid.')
            setWarningType('danger')
            return false
        } else {
            // This one is if the user is genesis
            if (res.data.genesis) {
                let parentUserId = res.data.genesis_userId
                setParentUserId(parentUserId)
                // updatePap(parentUserId)
                return true
            } else {
                const index = res.data.findIndex(
                    (innerArray) => innerArray[0] === 'Id'
                )

                // If "Id" is found, get the corresponding value
                let parentUserid = index !== -1 ? res.data[index][1] : null
                setParentUserId(parentUserid)
                // updatePap(parentUserid)

                console.log('parentUserId', parentUserid)
                return true
            }
            
        }
    }
    async function submit() {
        const isParentRefValid = await checkParentRefValidation()
        if (isParentRefValid) {
            const res = await addPap(parentUserId)
              
            if (res) {
                localStorage.setItem('parentRef', parentRef)
                setParentReferalWarning(true)
                setParentRefWarningMessage('Parent ref is added successfully.')
                setWarningType('success')
                setTimeout(() => {
                    setParentRefSubmitted(true)
                }, 3000)
            }
        }
    }
    return (
        <div>
            {parentReferalWarning && (
                <Alert closable type={warningType} onClose={onCloseClick}>
                    {parentRefWarningMessage}
                </Alert>
            )}
            <div className="card-parent-div">
                <Card>
                    <h3>
                        You dont have any parent Ref yet please add here to
                        proceed
                    </h3>
                    <Input
                        id="refId"
                        // invalid={invalid}
                        placeholder="RefId"
                        value={parentRef}
                        onChange={(e) => setParentRef(e.target.value)}
                    />

                    <div>
                        <Button
                            className="button bg-white border border-gray-300 dark:bg-gray-700 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 active:bg-gray-100 dark:active:bg-gray-500 dark:active:border-gray-500 text-gray-600 dark:text-gray-100 radius-round h-11 px-8 py-2"
                            type="submit"
                            disabled={parentRef ? false : true}
                            onClick={() => {
                                submit()
                            }}
                        >
                            Submit
                        </Button>
                    </div>
                </Card>
            </div>
        </div>
    )
}
export default ParentRef
